<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title>
						{{ $__("Create Catalogue") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-stepper v-model="stepper" vertical>
							<v-stepper-step
								step="1"
								:complete="stepper > 1"
								editable
								@click="stepper = 1"
							>
								{{ $__("Information") }}
								<small
									>Name, Availability, Hour, Description and
									Outlet</small
								>
							</v-stepper-step>
							<v-stepper-content step="1">
								<ShopFormCatalogue
									v-model="item"
									:outlets="outlets"
								></ShopFormCatalogue>
								<v-btn
									color="primary"
									@click.native="submit()"
									:loading="item.processing"
									:disabled="invalid"
								>
									<v-icon left>mdi-content-save</v-icon>
									Save & Continue
								</v-btn>
							</v-stepper-content>
							<v-stepper-step step="2" :complete="stepper > 2">
								{{ $__("Catalogue Menu") }}
								<small>Category, Product and Price</small>
							</v-stepper-step>
							<v-stepper-content step="2">
								&nbsp;
							</v-stepper-content>
						</v-stepper>
					</v-card-text>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import ShopFormCatalogue from "@Shop/forms/ShopFormCatalogue.vue";
export default {
	components: {
		ShopFormCatalogue,
	},

	props: ["outlets"],

	data() {
		return {
			stepper: 1,
			item: this.$inertia.form({
				title: null,
				descripiton: null,
				outlet_id: null,
				monday: false,
				tuesday: false,
				wednesday: false,
				thursday: false,
				friday: false,
				saturday: false,
				sunday: false,
				settings: {},
			}),
		};
	},

	methods: {
		submit() {
			this.item.post(
				this.$route(
					"tenant.catalogues.store",
					this.$page.props.tenant.id
				)
			);
		},
	},
};
</script>